var _g, _rect, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgViewHeaderModular(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "2 3 80 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_286_20468)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 82.0286,
    height: 59.4,
    rx: 4.71429,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 0.471436,
    width: 82.0286,
    height: 24.5143,
    fill: "#465DD8"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 7.94238,
    y: 10.4856,
    width: 26.4,
    height: 3.77143,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 7.94238,
    y: 18,
    width: 38,
    height: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.41381,
    y: 30.4714,
    width: 66.9429,
    height: 17.9143,
    rx: 1.41429,
    stroke: "#EEEEEE",
    strokeWidth: 0.942857
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8.0144,
    y: 54.2143,
    width: 66.9429,
    height: 17.9143,
    rx: 1.41429,
    stroke: "#EEEEEE",
    strokeWidth: 0.942857
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.9424,
    y: 12,
    width: 8,
    height: 8,
    rx: 1.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.9424,
    y: 12,
    width: 8,
    height: 8,
    rx: 1.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 67.9424,
    y: 12,
    width: 8,
    height: 8,
    rx: 1.5,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.471429,
    y: 0.471429,
    width: 81.0857,
    height: 58.4571,
    rx: 4.24286,
    stroke: "#E5E7EA",
    strokeWidth: 0.942857
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_286_20468"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1,
    width: 82.029,
    height: 59.4,
    rx: 4.714,
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewHeaderModular);
export default __webpack_public_path__ + "static/media/ViewHeaderModular.d3bf15af.svg";
export { ForwardRef as ReactComponent };